import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/src/js/lib/utils";

const badgeVariants = cva(
  "tw:inline-flex tw:w-fit tw:shrink-0 tw:items-center tw:justify-center tw:gap-1 tw:overflow-hidden tw:rounded-full tw:border tw:border-transparent tw:px-2 tw:py-0.5 tw:text-xs tw:font-medium tw:whitespace-nowrap tw:transition-[color,box-shadow] tw:outline-none tw:focus-visible:border-neutral-950 tw:focus-visible:ring-[3px] tw:focus-visible:ring-neutral-950/50 tw:[&>svg]:pointer-events-none tw:[&>svg]:size-3 tw:dark:focus-visible:border-neutral-300 tw:dark:focus-visible:ring-neutral-300/50",
  {
    variants: {
      variant: {
        default:
          "tw:bg-neutral-900 tw:text-neutral-50 tw:dark:bg-neutral-50 tw:dark:text-neutral-900",
        secondary:
          "tw:bg-neutral-100 tw:text-neutral-900 tw:dark:bg-neutral-800 tw:dark:text-neutral-50",
        destructive: "tw:bg-red-500 tw:text-white tw:dark:bg-red-900",
        outline:
          "tw:border-neutral-200 tw:text-neutral-950 tw:dark:border-neutral-800 tw:dark:text-neutral-50",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
